import routes from './routes';
import layouts from './layouts';
import views from './views';
import guardStart from './guards/start';
import guardAuth from './guards/auth';


const guards = [ guardStart, guardAuth ];


export {
	routes,
	layouts,
	views,
	guards,
};
